export const baseUrl = ""

interface HttpOptions {
    contentType?: string;
    accept?: string;
    authorize?: boolean;
};

interface Pagination {
    pageSize: number;
    pageNumber: number;
};

export async function get(url: string, options?: HttpOptions) {
    const headers = new Headers();
    headers.append("Accept", options?.accept ?? "application/json");

    if(options?.authorize) {
        const token = JSON.parse(localStorage.getItem("authToken") ?? "");
        headers.append("Authorization", "Bearer " + token);
    }

    const request = new Request(baseUrl + url, {
        method: "GET",
        headers: headers,
    });

    const response = await fetch(request);
    switch(response.status) {
        case 401: //unauthorized
            localStorage.removeItem("authToken"); //logout
            window.location.href = "/dashboard/login";
            break;
    }

    return response;
}

export async function post(url: string, body: any, options?: HttpOptions) {
    const headers = new Headers();
    headers.append("Content-Type", options?.contentType ?? "application/json");
    headers.append("Accept", options?.accept ?? "application/json");

    if(options?.authorize) {
        const token = JSON.parse(localStorage.getItem("authToken") ?? "");
        headers.append("Authorization", "Bearer " + token);
    }

    const request = new Request(baseUrl + url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body),
    });

    const response = await fetch(request);
    switch(response.status) {
        case 401: //unauthorized
            localStorage.removeItem("authToken"); //logout
            window.location.href = "/dashboard/login";
            break;
    }

    return response;
}

export async function _file(url: string, file: File, options?: HttpOptions) {
    const headers = new Headers();
    //headers.append("Content-Type", options?.contentType ?? "application/json");
    headers.append("Accept", options?.accept ?? "application/json");

    if(options?.authorize) {
        const token = JSON.parse(localStorage.getItem("authToken") ?? "");
        headers.append("Authorization", "Bearer " + token);
    }

    const formData = new FormData();
    formData.append(
        "file",
        file,
    );

    const request = new Request(baseUrl + url, {
        method: "POST",
        headers: headers,
        body: formData,
    });

    const response = await fetch(request);
    switch(response.status) {
        case 401: //unauthorized
            localStorage.removeItem("authToken"); //logout
            window.location.href = "/dashboard/login";
            break;
    }

    return response;
}

export async function _delete(url: string, options?: HttpOptions) {
    const headers = new Headers();
    headers.append("Accept", options?.accept ?? "application/json");

    if(options?.authorize) {
        const token = JSON.parse(localStorage.getItem("authToken") ?? "");
        headers.append("Authorization", "Bearer " + token);
    }

    const request = new Request(baseUrl + url, {
        method: "DELETE",
        headers: headers,
    });

    const response = await fetch(request);
    switch(response.status) {
        case 401: //unauthorized
            localStorage.removeItem("authToken"); //logout
            window.location.href = "/dashboard/login";
            break;
    }

    return response;
}

export async function patch(url: string, body: any, options?: HttpOptions) {
    const headers = new Headers();
    headers.append("Content-Type", options?.contentType ?? "application/json");
    headers.append("Accept", options?.accept ?? "application/json");

    if (options?.authorize) {
        const token = JSON.parse(localStorage.getItem("authToken") ?? "");
        headers.append("Authorization", "Bearer " + token);
    }

    const request = new Request(baseUrl + url, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(body),
    });

    const response = await fetch(request);
    switch (response.status) {
        case 401: // unauthorized
            localStorage.removeItem("authToken"); // logout
            window.location.href = "/dashboard/login";
            break;
    }

    return response;
}

interface LoginRequest {
    username: string;
    password: string;
};
export function login(request: LoginRequest) {
    return post("/api/Auth", request, { accept: "text/plain" });
}

export function uploadImage(file: File) {
    return _file("/api/Image/Upload", file, { authorize: true });
}

interface ComplaintSearchOptions {
    title: string;
    text: string;
};
interface SearchComplaintsRequest {
    options: ComplaintSearchOptions;
    pagination: Pagination;
};
export function searchComplaints(request: SearchComplaintsRequest) {
    return post("/api/Complaint/Search", request, { authorize: true });
}

interface AddComplaintRequest {
    organizationId?: number;
    title: string;
    text: string;
    imageId?: number;
};
export function addComplaint(request: AddComplaintRequest) {
    return post("/api/Complaint/Add", request, { authorize: true });
}

export function deleteComplaint(id: number) {
    return _delete("/api/Complaint/Delete/" + id, {authorize: true});
}

export function getComplaint(complaintId: number) {
    return get(`/api/Complaint/Get/${complaintId}`);
}

export function getComplaintAll() {
    return get(`/api/Complaint/GetAll`);
}

interface UpdateComplaintRequest {
    Id: number;
    title: string;
    text: string;
    published: boolean;
};
export function updateComplaint(request: UpdateComplaintRequest) {
    return patch("/api/Complaint/Update", request, { authorize: true });
}

interface SignComplaintRequest {
    complaintId: number;
    name: string;
    email: string;
    phone: string;
    subscribeNewsletter: boolean;
};
export function signComplaint(request: SignComplaintRequest) {
    return post("/api/Complaint/Sign", request, {authorize: false});
}

interface UserSearchOptions {
    name: string;
};
interface SearchUsersRequest {
    options: UserSearchOptions;
    pagination: Pagination;
};
export function searchUsers(request: SearchUsersRequest) {
    return post("/api/User/Search", request, { authorize: true });
}

export function getInstitutions() {
    return get(`/api/Institution/GetAll`, { authorize: true });
}

interface SendEmailRequest {
    complaintId: number;
    institutionIds: number[];
};
export function sendEmail(request: SendEmailRequest) {
    return post(`/api/Complaint/SendEmail`, request, { authorize: true });
}

export function getForms() {
    return get("/api/Form/GetAll");
}

export interface AddFormRequest {
    name: string;
    link: string;
}

export interface UpdateFormRequest {
    id: number;
    name: string;
    link: string;
}

export function addForm(data: AddFormRequest) {
    return post("/api/Form/Add", data, { authorize: true });
}

export function updateForm(data: UpdateFormRequest) {
    return post("/api/Form/Update", data, { authorize: true });
}

export function deleteForm(id: number) {
    return _delete("/api/Form/Delete/" + id, { authorize: true });
}

